<template>
  <div class="modal-menu">
    <DefDarkenBackground :z-index="10000" @close="hide" />
    <DefSlideLeft appear @afterLeave="afterLeave">
      <div v-if="isOpen.value" class="modal-menu-content">
        <slot />
      </div>
    </DefSlideLeft>
  </div>
</template>

<script lang="ts" setup>
import DefSlideLeft from '@components/Def/DefAnimations/DefSlideLeft.vue';
import DefDarkenBackground from '@components/Def/DefDarkenBackground/DefDarkenBackground.vue';
import useModalMenu from '@use/useModalMenu/useModalMenu';
import { Ref } from 'vue';

const modalAside = useModalMenu();

const props = defineProps<{
  isOpen: Ref;
  options?: {
    width?: string;
    backgroundClose?: boolean;
    empty?: boolean;
    padding?: boolean;
  };
  afterLeave: () => void;
  // afterRemove: () => void;
}>();

const hide = () => {
  modalAside.hide();
};
</script>

<style lang="scss" scoped>
.modal-menu {
}
.modal-menu-content {
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 10001;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: #fff;
  width: 100%;
  @include point-md {
    width: 400px;
  }
  :deep(> *) {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  //@include point-lg {
  //  width: 840px;
  //}
}
</style>
